import { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import BiographyPage from "@/pages/BiographyPage";
import DiscographyPage from "@/pages/DiscographyPage";
import AwardsPage from "@/pages/AwardsPage";
import GalleryPage from "@/pages/GalleryPage";
import PressPage from "@/pages/PressPage";
import EventPage from "@/pages/EventPage";
import MasterclassPage from "@/pages/MasterclassPage";
import StageZeroPage from "@/pages/StageZeroPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -60 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <SmoothScroll />
          <div className="grain" />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/biography" element={<BiographyPage />} />
              <Route path="/discography" element={<DiscographyPage />} />
              <Route path="/awards" element={<AwardsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/press" element={<PressPage />} />
              <Route path="/the-weekend" element={<EventPage />} />
              <Route path="/masterclass" element={<MasterclassPage />} />
              <Route path="/stage-zero" element={<StageZeroPage />} />
            </Route>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
